import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { LoggingSwitch } from "./utils/console";
import { ToastContainer } from "react-toastify/unstyled";
import { createRouter, RouterProvider } from "@tanstack/react-router";
// The `unstyled` entrypoint is used everywhere `react-toastify` is imported because the default one
// injects this stylesheet as an inline `<style>` element at runtime, which our `style-src 'self'` CSP
// blocks. Importing the (identical) stylesheet here bundles it as a regular asset instead.
// All `react-toastify` imports must stay on the same entrypoint - mixing them gives `toast()` and
// `<ToastContainer />` separate module state, so no toast would ever be rendered.
import "react-toastify/dist/ReactToastify.css";

// Import i18n to initialize it
import "./i18n";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
    // eslint-disable-next-line
    interface Register {
        // eslint-disable-next-line
        router: typeof router;
    }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <>
        <LoggingSwitch />
        <ToastContainer toastClassName={"toast-message"} closeOnClick={true} />
        <RouterProvider router={router} />
    </>,
);
